import { SvgIcon, type SvgIconProps } from "@mui/material";

interface PeopleProps extends SvgIconProps {
  variant?: "regular" | "bold";
}

export function People({ variant = "regular", ...props }: PeopleProps) {
  const pathData =
    variant === "bold"
      ? [
          {
            id: "group1",
            path: "M0.949951 17.65V20H16.95V17.65C16.95 17.0666 16.7958 16.5375 16.4874 16.0625C16.1791 15.5875 15.7583 15.2333 15.225 15C14.0083 14.4666 12.9166 14.0833 11.95 13.85C10.9833 13.6166 9.98328 13.5 8.94995 13.5C7.91662 13.5 6.91245 13.6166 5.93745 13.85C4.96245 14.0833 3.86662 14.4666 2.64995 15C2.11662 15.2333 1.69995 15.5875 1.39995 16.0625C1.09995 16.5375 0.949951 17.0666 0.949951 17.65Z",
          },
          {
            id: "group2",
            path: "M18.7999 14.0125C17.7833 13.7541 16.7 13.5583 15.55 13.425C16.4166 13.8416 17.1166 14.3875 17.6499 15.0625C18.1833 15.7375 18.4499 16.6 18.4499 17.65V20H23.0499V17.65C23.0499 17.0666 22.8916 16.5416 22.5749 16.075C22.2583 15.6083 21.8249 15.2166 21.2749 14.9C20.6416 14.5666 19.8166 14.2708 18.7999 14.0125Z",
          },
          {
            id: "person1",
            path: "M6.24995 10.925C6.94995 11.625 7.84995 11.975 8.94995 11.975C10.05 11.975 10.95 11.625 11.65 10.925C12.3499 10.225 12.7 9.32498 12.7 8.22498C12.7 7.12498 12.3499 6.22498 11.65 5.52498C10.95 4.82498 10.05 4.47498 8.94995 4.47498C7.84995 4.47498 6.94995 4.82498 6.24995 5.52498C5.54995 6.22498 5.19995 7.12498 5.19995 8.22498C5.19995 9.32498 5.54995 10.225 6.24995 10.925Z",
          },
          {
            id: "person2",
            path: "M16.9 10.925C17.6 10.225 17.9499 9.32498 17.9499 8.22498C17.9499 7.12498 17.6 6.22498 16.9 5.52498C16.2 4.82498 15.2999 4.47498 14.2 4.47498C14.0166 4.47498 13.8125 4.49164 13.5875 4.52498C13.3624 4.55831 13.1583 4.59998 12.975 4.64998C13.375 5.13331 13.6791 5.66248 13.8875 6.23748C14.0958 6.81248 14.2 7.47498 14.2 8.22498C14.2 8.97498 14.0958 9.65414 13.8875 10.2625C13.6791 10.8708 13.375 11.3833 12.975 11.8C13.1583 11.8666 13.3624 11.9125 13.5875 11.9375C13.8125 11.9625 14.0166 11.975 14.2 11.975C15.2999 11.975 16.2 11.625 16.9 10.925Z",
          },
        ]
      : [
          {
            id: "group",
            path: "M0.949951 20V17.65C0.949951 17.0666 1.09995 16.5375 1.39995 16.0625C1.69995 15.5875 2.11662 15.2333 2.64995 15C3.86662 14.4666 4.96245 14.0833 5.93745 13.85C6.91245 13.6166 7.91662 13.5 8.94995 13.5C9.98328 13.5 10.9833 13.6166 11.95 13.85C12.9166 14.0833 14.0083 14.4666 15.225 15C15.7583 15.2333 16.1791 15.5875 16.4874 16.0625C16.7958 16.5375 16.95 17.0666 16.95 17.65V20H0.949951Z",
          },
          {
            id: "group-extra",
            path: "M15.55 13.425C16.7 13.5583 17.7833 13.7541 18.7999 14.0125C19.8166 14.2708 20.6416 14.5666 21.2749 14.9C21.8249 15.2166 22.2583 15.6083 22.5749 16.075C22.8916 16.5416 23.0499 17.0666 23.0499 17.65V20H18.4499V17.65C18.4499 16.6 18.1833 15.7375 17.6499 15.0625C17.1166 14.3875 16.4166 13.8416 15.55 13.425Z",
          },
          {
            id: "person1",
            path: "M8.94995 11.975C7.84995 11.975 6.94995 11.625 6.24995 10.925C5.54995 10.225 5.19995 9.32498 5.19995 8.22498C5.19995 7.12498 5.54995 6.22498 6.24995 5.52498C6.94995 4.82498 7.84995 4.47498 8.94995 4.47498C10.05 4.47498 10.95 4.82498 11.65 5.52498C12.3499 6.22498 12.7 7.12498 12.7 8.22498C12.7 9.32498 12.3499 10.225 11.65 10.925C10.95 11.625 10.05 11.975 8.94995 11.975Z",
          },
          {
            id: "person2",
            path: "M17.9499 8.22498C17.9499 9.32498 17.6 10.225 16.9 10.925C16.2 11.625 15.3 11.975 14.2 11.975C14.0166 11.975 13.8125 11.9625 13.5875 11.9375C13.3625 11.9125 13.1583 11.8666 12.975 11.8C13.375 11.3833 13.6791 10.8708 13.8875 10.2625C14.0958 9.65414 14.2 8.97498 14.2 8.22498C14.2 7.47498 14.0958 6.81248 13.8875 6.23748C13.6791 5.66248 13.375 5.13331 12.975 4.64998C13.1583 4.59998 13.3625 4.55831 13.5875 4.52498C13.8125 4.49164 14.0166 4.47498 14.2 4.47498C15.3 4.47498 16.2 4.82498 16.9 5.52498C17.6 6.22498 17.9499 7.12498 17.9499 8.22498Z",
          },
          {
            id: "highlight1",
            path: "M2.44995 18.5H15.45V17.65C15.45 17.3833 15.3708 17.125 15.2125 16.875C15.0541 16.625 14.8583 16.45 14.625 16.35C13.425 15.8166 12.4166 15.4583 11.6 15.275C10.7833 15.0916 9.89995 15 8.94995 15C7.99995 15 7.11245 15.0916 6.28745 15.275C5.46245 15.4583 4.44995 15.8166 3.24995 16.35C3.01662 16.45 2.82495 16.625 2.67495 16.875C2.52495 17.125 2.44995 17.3833 2.44995 17.65V18.5Z",
          },
          {
            id: "highlight2",
            path: "M8.94995 10.475C9.59995 10.475 10.1375 10.2625 10.5625 9.83748C10.9875 9.41248 11.2 8.87498 11.2 8.22498C11.2 7.57498 10.9875 7.03748 10.5625 6.61248C10.1375 6.18748 9.59995 5.97498 8.94995 5.97498C8.29995 5.97498 7.76245 6.18748 7.33745 6.61248C6.91245 7.03748 6.69995 7.57498 6.69995 8.22498C6.69995 8.87498 6.91245 9.41248 7.33745 9.83748C7.76245 10.2625 8.29995 10.475 8.94995 10.475Z",
          },
        ];

  return (
    <SvgIcon
      {...props}
      viewBox="0 0 24 24"
      sx={{
        color: "white",
        fontSize: "24px",
        ...props.sx,
      }}
    >
      {pathData.map((item) => (
        <path key={item.id} d={item.path} />
      ))}
    </SvgIcon>
  );
}
